export default __webpack_public_path__ + "static/media/Forever-Pension-Brochure.3fc5d5e0.pdf";